import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import MainLogo from '../../../assets/images/Logo_AiLogistic.jpg';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <Link component={RouterLink} to={DASHBOARD_PATH}>
        <img src={MainLogo} alt="AI Logistic" className="sidebar-logo" />
    </Link>
);

export default LogoSection;
